<div class="card-header">
    <h4 class="card-title chart-card-title">{{chart.title}} <span *ngIf="typeName == 'visibility'" class="badge badge-primary">ADMIN</span></h4>
    
    <p class="category">Funil de {{chart.title}} da sua loja no período.</p>
</div>

<div class="card-content">
    <div class="chart-container">
        <div class="row flex-chart-container">
            <div class="cabianca-space-slot"></div>
            <div class="header-bar-item">
                <h5>Total Visitas</h5>
            </div>
            <div class="header-bar-item"></div>
            <div class="header-bar-item">
                <h5>Produto</h5>
            </div>
            <div class="header-bar-item"></div>
            <div class="header-bar-item">
                <h5>Carrinho</h5>
            </div>
            <div class="header-bar-item"></div>
            <div class="header-bar-item">
                <h5>Checkout</h5>
            </div>
            <div class="header-bar-item"></div>
            <div class="header-bar-item">
                <h5>Vendas</h5>
            </div>
            <div class="cabianca-space-slot"></div>
        </div>
        <div class="row flex-chart-container row-chart-main-number">
            <div class="cabianca-space-slot"></div>
            <tooltip-content #TotalVisits>        
                    <span>É o número de visitantes únicos total da sua loja. </span>
            </tooltip-content>
            <div class="header-bar-item">
                <p [tooltip]="TotalVisits" >{{chart.bars[0].total | number}}</p>
            </div>
            <tooltip-content #totalPercent>        
                    <span>Percentual de visitantes que acessaram uma ou mais páginas de produtos.</span>         
            </tooltip-content>
            <div class="header-bar-item-2">
                <div [tooltip]="totalPercent" id="pointer" [ngClass]="'pointer-main'">{{chart.arrows[0].percentage | number:'.1-1'}}%</div>
            </div>
            <tooltip-content #productVisit>        
                    <span>É o número de visitantes que visualizaram um produto ou mais. </span>
            </tooltip-content>
            <div class="header-bar-item">
                <p [tooltip]="productVisit">{{chart.bars[1].total | number}}</p>
            </div>
            <tooltip-content #productCartPercent>        
                    <span>Percentual de visitantes que avançaram para a página de carrinho/sacola. </span>                    
            </tooltip-content>
            <div class="header-bar-item-2">
                <div [tooltip]="productCartPercent" id="pointer" [ngClass]="'pointer-main'">{{chart.arrows[1].percentage | number:'.1-1'}}%</div>
            </div>
            <tooltip-content #cartVisit>        
                    <span>É o número de visitantes que chegaram até a página de carrinho/sacola da sua loja. </span>
            </tooltip-content>
            <div class="header-bar-item">
                <p [tooltip]="cartVisit">{{chart.bars[2].total | number}}</p>
            </div>
            <tooltip-content #cartCheckoutPercent>        
                    <span>Percentual de visitantes que foram da página de carrinho para a página de checkout/pagamento. </span>                    
            </tooltip-content>
            <div class="header-bar-item-2">
                <div [tooltip]="cartCheckoutPercent" id="pointer" [ngClass]="'pointer-main'">{{chart.arrows[2].percentage | number:'.1-1'}}%</div>
            </div>
            <tooltip-content #checkoutVisit>        
                    <span>É o número de visitantes que chegaram até a página de checkout/pagamento da sua loja. </span>
            </tooltip-content>
            <div class="header-bar-item">
                <p [tooltip]="checkoutVisit">{{chart.bars[3].total | number}}</p>
            </div>
            <tooltip-content #checkoutThankPercent>        
                    <span>Percentual de visitantes que continuaram da página de checkout/pagamento para a finalização de compra. </span>                    
            </tooltip-content>
            <div class="header-bar-item-2">
                <div [tooltip]="checkoutThankPercent" id="pointer" [ngClass]="'pointer-main'">{{chart.arrows[3].percentage | number:'.1-1'}}%</div>
            </div>
            <tooltip-content #thankyouPurchase>        
                    <span>É o número prévio total de vendas concluídas da sua loja no período. (não leva em conta se pagou ou não)</span>
            </tooltip-content>
            <div class="header-bar-item">
                <p [tooltip]="thankyouPurchase">{{chart.bars[4].total | number}}</p>
            </div>
            <div class="cabianca-space-slot"></div>
        </div>
        <div class="row flex-chart-container"  *ngIf="chart && typeName == 'engagement'">
            <div class="cabianca-space-slot"></div>
            <app-slotbar [class]="'cabianca-space-slot'" [typeChart]="typeName" [type]="'allsite'" [bar]="chart.bars[0]"></app-slotbar>
            <app-slotarrow [class]="'cabianca-space-slot'" [type]="'allsite'" [arrow]="chart.arrows[0]"></app-slotarrow>
            <app-slotbar [class]="'cabianca-space-slot'" [typeChart]="typeName"  [type]="'allsite'" [bar]="chart.bars[1]"></app-slotbar>
            <app-slotarrow [class]="'cabianca-space-slot'" [type]="'allsite'" [arrow]="chart.arrows[0]"></app-slotarrow>
            <!-- <app-slotarrow *ngIf="!isAdmin"  [class]="'cabianca-space-slot'" [type]="'allsite'" [arrow]="chart.arrows[0]"></app-slotarrow> -->
            <!-- <app-slotarrow *ngIf="isAdmin" [class]="'cabianca-space-slot'" [arrow]="chart.arrows[1]"></app-slotarrow> -->
            <app-slotbar [class]="'cabianca-space-slot'" [bar]="chart.bars[2]"></app-slotbar>
            <app-slotarrow [class]="'cabianca-space-slot'" [arrow]="chart.arrows[2]"></app-slotarrow>
            <app-slotbar [class]="'cabianca-space-slot'" [bar]="chart.bars[3]"></app-slotbar>
            <app-slotarrow [class]="'cabianca-space-slot'" [arrow]="chart.arrows[3]"></app-slotarrow>
            <app-slotbar [class]="'cabianca-space-slot'" [bar]="chart.bars[4]"></app-slotbar>
            <div class="cabianca-space-slot"></div>

        </div>
        <div class="row flex-chart-container" *ngIf="chart && typeName == 'visibility'">
                <div class="cabianca-space-slot"></div>
                <app-slotbar [class]="'cabianca-space-slot'" [typeChart]="typeName" [bar]="chart.bars[0]"></app-slotbar>
                <app-slotarrow [class]="'cabianca-space-slot'" [arrow]="chart.arrows[0]"></app-slotarrow>
                <app-slotbar [class]="'cabianca-space-slot'" [typeChart]="typeName"  [bar]="chart.bars[1]"></app-slotbar>
                <app-slotarrow [class]="'cabianca-space-slot'" [arrow]="chart.arrows[1]"></app-slotarrow>
                <app-slotbar [class]="'cabianca-space-slot'" [bar]="chart.bars[2]"></app-slotbar>
                <app-slotarrow [class]="'cabianca-space-slot'" [arrow]="chart.arrows[2]"></app-slotarrow>
                <app-slotbar [class]="'cabianca-space-slot'" [bar]="chart.bars[3]"></app-slotbar>
                <app-slotarrow [class]="'cabianca-space-slot'" [arrow]="chart.arrows[3]"></app-slotarrow>
                <app-slotbar [class]="'cabianca-space-slot'" [bar]="chart.bars[4]"></app-slotbar>
                <div class="cabianca-space-slot"></div>
    
            </div>
        <div class="row flex-chart-container">
            <div class="legend-chart">
                <div class="legend-box-color section-polen"></div>
                <span style="width: 300px;" *ngIf="chart.title == 'visibilidade'">Visitas que viram o Polen.</span>
                <span *ngIf="chart.title != 'visibilidade'">Consumidores polinizando.</span>

            </div>
            <div class="legend-chart">
                <div class="legend-box-color section-original"></div>
                <span style="width: 300px;" *ngIf="chart.title == 'visibilidade'">Visitas no site sem ver o Polen.</span>
                <span *ngIf="chart.title != 'visibilidade'">Consumidores não polinizando.</span>
            </div>

        </div>
    </div>
</div>